import { memo, useEffect } from "react";
import Button from "../../../components/Button/Button";
import { useAuth } from "../../../utils/hooks/useAuth";
import type { GlobalNotificationT } from "../../NewPrices2024/models/models";
import usePopup from "../../../utils/hooks/usePopup";
import { selectTranslatedString } from "../../../store/selectors/appSelectors";
import { useAppSelector } from "../../../store/hooks";

import styles from "./styles.module.scss";

interface GlobalNotificationPopupI {
  notification: GlobalNotificationT;
  isPreview?: boolean;
}

/**
 * The popup shows a global notification from global settings for all users.
 */
const GlobalNotificationPopup = memo((props: GlobalNotificationPopupI) => {
  const { notification, isPreview } = props;
  const { removePopup } = usePopup();
  const translatedStrings = useAppSelector(selectTranslatedString);

  const { currentUser } = useAuth();

  useEffect(() => {
    if (!isPreview) {
      // Mark the notification as read in the local storage
      const storageKey = `notification-${notification.TitleConst}-${currentUser?.id}`;

      localStorage.setItem(storageKey, "true");
    }
  }, [currentUser?.id, notification.TitleConst, isPreview]);

  return (
    <div className={styles.globalNotificationPopupWrapper}>
      <h1
        dangerouslySetInnerHTML={{
          __html: translatedStrings?.[notification.TitleConst],
        }}
      />
      <p
        dangerouslySetInnerHTML={{
          __html: translatedStrings?.[notification.DescriptionConst],
        }}
      />
      <Button onClick={removePopup}>Got it</Button>
    </div>
  );
});

export default GlobalNotificationPopup;
